import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session6 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const pseudo = firebase.userData.pseudo;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respQuestions, setRespQuestions] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bonjour et bienvenue !</h3>
            <p>
              Parfois, on peut entendre qu’il faut « se mettre à la place des
              autres ». Pas toujours facile… Aujourd’hui, nous allons découvrir
              comment la prise de perspective d’une autre personne peut
              participer à l’altruisme et à l’entraide.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1gbCWPgPFklf4o1iSSdpe-sB3Ixa-aXnFuT7mRfhWXLY"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                La capacité à se représenter les états mentaux d’autrui
                s’appelle :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="theorieDesDeuxEsprits"
                  control={<Radio />}
                  label="La théorie des deux esprits"
                />
                <FormControlLabel
                  value="theorieDeLesprit"
                  control={<Radio />}
                  label="La théorie de l’esprit"
                />
                <FormControlLabel
                  value="theorieDeMonEsprit"
                  control={<Radio />}
                  label="La théorie de mon esprit"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Lors de la dernière séance, tu as réfléchi aux éléments à disposer
              sur l’affiche de ta série ou de ton film préféré pour décrire à
              des amis ou camarades.
            </p>

            <p>Continuons !</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              Place à la créativité : prends une feuille de papier, ou un
              logiciel informatique si tu sais t’en servir.{' '}
            </p>
            <p>
              Prends le temps de créer ton affiche en y mettant ton slogan, les
              mots que tu as choisis, et les illustrations de ton choix.
            </p>
            <p>
              Une fois que ton affiche est terminée, prends-la en photo ou
              demande à un adulte de le faire pour toi, pour ensuite me
              l'envoyer à cette adresse email:
              <a
                style={{color: 'black', fontWeight: 'bold'}}
                HREF="mailto:projetaltri@gmail.com"
              >
                {' '}
                projetaltri@gmail.com
              </a>
            </p>
            <p>
              Lors de l'envoi de ton affiche, tu peux mettre comme objet du
              message (n'oublie pas de me préciser ton pseudo !) : "Mon affiche
              ({pseudo})"
            </p>
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te
              reconnecter dans quelques jours pour notre prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Lors de la dernière séance, tu as réfléchi aux éléments à
                disposer sur le poster de ta cause de bénévolat pour donner
                envie à des camarades de te rejoindre.
              </p>
              <p>Continuons !</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              <p>
                Place à la créativité : prends une feuille de papier, ou un
                logiciel informatique si tu sais t’en servir.{' '}
              </p>
              <p>
                Prends le temps de créer ton affiche en y mettant ton slogan,
                les mots que tu as choisis, et les illustrations de ton choix.
              </p>
              <p>
                Une fois que ton affiche est terminée, prends-la en photo ou
                demande à un adulte de le faire pour toi, pour ensuite me
                l'envoyer à cette adresse email:
                <a
                  style={{color: 'black', fontWeight: 'bold'}}
                  HREF="mailto:projetaltri@gmail.com"
                >
                  {' '}
                  projetaltri@gmail.com
                </a>
              </p>
              <p>
                Lors de l'envoi de ton affiche, tu peux mettre comme objet du
                message (n'oublie pas de me préciser ton pseudo !) : "Mon
                affiche ({pseudo})"
              </p>
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                connecter dans quelques jours pour la prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session6')
              .add({
                date: now,
                response: response,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session6;
